/**
 * The public Voucher Redemption Locator is also served from uslawshield.com hostnames (owner GO 2026-10-15) so the
 * referrer-restricted Google Maps browser key works there:
 *   QA   https://qa-locator.uslawshield.com/voucher-locations   (same build root as qa-uslscrm.trysynapse.ai)
 *   PROD https://locator.uslawshield.com/voucher-locations      (same build root as uslscrm.trysynapse.ai)
 *
 * nginx on those hosts serves ONLY the locator page and its static files (deploy/nginx/locator-domain/). This module
 * is the in-app half of the same rule: on a locator host the SPA mounts a router that knows only the locator route,
 * so a client-side navigation can never render a CRM screen there.
 */

export const LOCATOR_PATH = "/voucher-locations";

export const LOCATOR_HOSTS = {
  qa: "qa-locator.uslawshield.com",
  production: "locator.uslawshield.com",
} as const;

export function isLocatorHost(hostname: string): boolean {
  const h = hostname.trim().toLowerCase().replace(/\.$/, "");
  return h === LOCATOR_HOSTS.qa || h === LOCATOR_HOSTS.production;
}
